module.exports = __webpack_public_path__ + "static/img/yewu.54134546.jpg";